import { render, staticRenderFns } from "./KanbanListView.vue?vue&type=template&id=9a6628c4&"
import script from "./KanbanListView.vue?vue&type=script&lang=js&"
export * from "./KanbanListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports